import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { API_URL } from "../config";
import { useCatalogos } from "../CONTEXTO/CatalogosContext";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { cargarCatalogos } = useCatalogos();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert("Ingresa tu correo y contraseña");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, password })
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.msg || "Credenciales incorrectas");
        setLoading(false);
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("alias", data.usuario.nombre);
      localStorage.setItem("rol", data.usuario.rol);

      await cargarCatalogos();
      navigate("/inicio");

    } catch (error) {
      console.error(error);
      alert("Error al conectar con el servidor");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">

      {/* COLUMNA IZQUIERDA */}
      <div className="login-left">
        <h1 className="login-title">
          Gestión financiera inteligente, en un solo lugar.
        </h1>

        {/* 🔥 LOGO DEBAJO DEL TEXTO */}
        <img
          src="/logo_sin_fondo.png"
          alt="Logo Institucional"
          className="login-left-logo"
        />

        <p className="login-subtitle">
          Accede a tu cartera, pipeline de crédito y métricas de cobranza en tiempo real.
        </p>
        
      </div>

      {/* COLUMNA DERECHA */}
      <div className="login-right">
        {/* 🔥 LOGO DEBAJO DEL TEXTO */}
        <img
          src="/logo_encabezado.png"
          alt="Logo Institucional"
          className="login-right-logo"
        />

        <div className="login-box-modern">
          <h2>Bienvenido de vuelta</h2>

          <form onSubmit={handleLogin}>
            <label>CORREO INSTITUCIONAL</label>
            <input
              type="email"
              placeholder="usuario@institucion.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <label>CONTRASEÑA</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button type="submit" disabled={loading} className="btn-login">
              {loading ? "Validando..." : "Iniciar sesión"}
            </button>
          </form>

          <p className="login-footer">
            Acceso restringido a personal autorizado v2.4.1
          </p>
        </div>
      </div>

    </div>
  );
}





